import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TaskService } from 'src/app/services/task/task.service';

@Component({
  selector: 'app-detail-task',
  templateUrl: './detail-task.component.html',
  styleUrls: ['./detail-task.component.sass']
})
export class DetailTaskComponent implements OnInit {

  task;

  constructor(
    private activatedRoute: ActivatedRoute,
    private taskService: TaskService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(({ id }) => { 
      
      this.taskService.findOne(id).subscribe(res => {
        
        this.task = res;
      })
    })
  }

  onUpdate() {
    
  }

}
